export const CERTIFICATION_STATUS = {
  NOT_STARTED: 'not_started',
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  OUT_OF_ATTEMPTS: 'out_of_attempts',
  CERTIFIED: 'certified',
  COMPLETED: 'completed',
} as const;

export type CertificationStatus = typeof CERTIFICATION_STATUS[keyof typeof CERTIFICATION_STATUS];
